const relationshipFields = [
	{id: "supportContext", title: "What is supportive in this relationship?", source: "reported"},
	{id: "strainContext", title: "What is difficult in this relationship?", source: "reported"},
	{id: "changes", title: "What has changed?\nHow would you like the relationship to be different?", source: "reported"},
	{id: "stressors", title: "What interpersonal stressors are relevant?", source: "reported", role: "stressor"},
	{id: "presentingLink", title: "How might this relationship relate to the presenting problem?\nHow might the presenting problem affect this relationship?", source: "reported", role: "presentingLink"},
]

export function createInterpersonalInventoryConfig() {
	return {
		title: "Interpersonal Inventory",
		instructions: "During the assessment, record people who matter in the client's life. Place each person by closeness, then discuss support, strain, changes, and possible links to the presenting problem. Leave uncertain information open.",
		entryLabel: "Significant relationship",
		entryPlaceholder: "Person and relationship",
		contextTitle: "Presenting context",
		choiceTitle: "Support and strain",
		choiceOptions: [
			{value: "support", label: "Supportive"},
			{value: "strain", label: "Stressful"},
		],
		periodTitle: "Relationship context",
		periodOptions: [
			{value: "current", label: "Current"},
			{value: "past", label: "Past"},
			{value: "deceased", label: "Deceased person"},
		],
		formulationTitle: "Practitioner formulation notes",
		themeTitle: "Relationship themes",
		reportedTitle: "Client-reported context",
		practitionerTitle: "Practitioner observations",
		entryFields: relationshipFields.map(field => ({...field, responseType: "multiline", placeholder: ""})),
		stages: [
			{id: "intimate", title: "Intimate supports", description: "People closest to the client", itemLabel: "Relationship", allowAlternatives: false},
			{id: "close", title: "Close supports", description: "People the client feels close to", itemLabel: "Relationship", allowAlternatives: false},
			{id: "extended", title: "Extended supports", description: "People farther from the client who still matter", itemLabel: "Relationship", allowAlternatives: false},
		],
	}
}

export function createInterpersonalInventoryDemoPayload() {
	return {
		stagedWorksheet: {
			context: "Recent withdrawal after a difficult few months at work.",
			stages: [
				{id: "intimate", items: [
					{id: "mara", text: "Mara, partner", values: {period: "current", choices: ["support", "strain"], supportContext: "Offers practical help and listens after work.", strainContext: "Recent arguments about time together.", presentingLink: "Arguments may be adding to withdrawal."}},
				]},
				{id: "close", items: [
					{id: "jonas", text: "Jonas, friend", values: {period: "current", choices: ["support"], supportContext: "Checks in most weekends."}},
				]},
				{id: "extended", items: []},
			],
		},
	}
}
